interface Props {
  /** Full opaque quote slug. The badge takes the first 5 chars and
   *  uppercases them, mirroring the `Q-XXXXX` format that the legacy
   *  laser PageHeader has been showing. */
  quoteId: string;
}

/** Veřejné ID dílu, jak ho zákazník vidí v konfigurátoru (``Q-XXXXX``).
 *  Jedno místo pro odznak i předmět poptávky (KAN-1650). */
export function quoteShortId(quoteId: string): string {
  return `Q-${quoteId.slice(0, 5).toUpperCase()}`;
}

export function QuoteIdBadge({ quoteId }: Props): JSX.Element {
  const shortId = quoteShortId(quoteId);
  return (
    <span
      className="mono rounded border border-border-strong bg-surface px-2 py-0.5 text-[11px] text-ink-2"
      data-testid="quote-id-badge"
    >
      ID: {shortId}
    </span>
  );
}
